const qwen = {
    toolsImg: require("@/assets/icon/tongyi-icon.png"),
    toolsTitle: "通义千问",
    toolsTag: "开源基座大模型",
    toolsDes: "阿里云构建的大型语言模型家族",


    toolsChild: [
        {
            toolsChildId: 0,
            toolsTitle: "Qwen2.5系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "Qwen2.5-Math",
                    cardDes: "Qwen2.5 数学模型系列",
                    cardLink: "https://modelscope.cn/collections/Qwen25-Math-21874a36a126a4"
                },
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "Qwen2.5-Math PRM系列",
                    cardDes: "Qwen ProcessBench 相关模型",
                    cardLink: "https://modelscope.cn/collections/Qwen25-Math-PRM-xilie-f704f36962cf4b"
                },

                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "Qwen2.5-1M",
                    cardDes: "通义千问2.5 - 长上下文（1M context）系列",
                    cardLink: "https://modelscope.cn/collections/Qwen25-1M-d6cf9fd33f0a40"
                },
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "Qwen2.5-Coder",
                    cardDes: "通义千问2.5 代码模型系列",
                    cardLink: "https://modelscope.cn/collections/Qwen25-Coder-9d375446e8f5814a"
                },
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "Qwen2.5",
                    cardDes: "通义千问2.5 大语言模型，包括预训练以及nstruction-tuned 系列模型，涵盖 0.5B, 1.5B, 3B, 7B, 14B, 32B, and 72B不同大小",
                    cardLink: "https://modelscope.cn/collections/Qwen25-dbc4d30adb768"
                },
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "Qwen2.5-VL",
                    cardDes: "通义千问2.5-视觉模型VL系列。",
                    cardLink: "https://modelscope.cn/collections/Qwen25-VL-58fbb5d31f1d47"
                },

            ]
        },
        {
            toolsChildId: 1,
            toolsTitle: "QwQ系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "QwQ-32B",
                    cardDes: "通义千问-QwQ-32B推理模型",
                    cardLink: "https://modelscope.cn/collections/QwQ-32B-0f1806b8a8514a"
                },


            ]
        },
        {
            toolsChildId: 2,
            toolsTitle: "QvQ系列",
            cardList: [
                {
                    cardImg: require("@/assets/icon/tongyi-icon.png"),
                    cardTitle: "QVQ-72B-Preview",
                    cardDes: "QVQ-72B-Preview is an experimental research model developed by the Qwen team, focusing on enhancing visual reasoning capabilities.",
                    cardLink: "https://modelscope.cn/models/Qwen/QVQ-72B-Preview"
                },


            ]
        },

    ],
};
export default qwen;